import React, { useState } from 'react'
import { Box } from '@mui/material'
import { EdifyButton } from '../../components/buttons'
import { EdifyFieldLabel, EdifyFormField } from '../../components/form'
import { ErrorToast, SuccessToast } from '../../../core/utils/toast-notifications/ToastNotifications'

import { AdminFormUpdate } from '../../../domain/domain'
import EdifySearchDropdown, { ISearchResult } from '../../components/form/EdifySearch/EdifySearchDropdown'
import InnerPageContainer from '../../components/inner-page-container/InnerPageContainer'
import { IForm } from '../../../domain/interfaces/IForm'
import { useOrganizationProvider } from '../../../providers/OrganizationProvider'

interface FencesFormProps {
  form: IForm
}

export const FencesForm: React.FC<FencesFormProps> = ({ form }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { getHierarchyName } = useOrganizationProvider()

  const [selectedLevels, setSelectedLevels] = useState<ISearchResult[]>(form.levels ?? [])
  const [selectedProjects, setSelectedProjects] = useState<ISearchResult[]>(form.projects ?? [])
  const [selectedContractors, setSelectedContractors] = useState<ISearchResult[]>(form.contractors ?? [])

  const levelsSelected = (allLevels: ISearchResult[]) => {
    setSelectedLevels(allLevels)
  }

  const projectsSelected = (allProjects: ISearchResult[]) => {
    setSelectedProjects(allProjects)
  }

  const contractorsSelected = (contractors: ISearchResult[]) => {
    setSelectedContractors(contractors)
  }

  const handleSubmit = async () => {
    setLoading(true)
    const levelIds = selectedLevels.map(level => level.id)
    const projectIds = selectedProjects.map(project => project.id)
    const contractorIds = selectedContractors.map(contractor => contractor.id)

    const res = await AdminFormUpdate(form.id, {
      levelIds,
      projectIds,
      contractorIds,
    })
    setLoading(false)
    if (res.isRight()) {
      SuccessToast({ title: 'Fences Form Updated Successfully' })
    }
    if (res.isLeft()) {
      ErrorToast({ title: res.left?.message ?? 'Error Updating Fences Form' })
    }
  }

  return (
    <InnerPageContainer headerTitle='Fences' collapsible collapsed={true}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}>
        <EdifyFormField>
          <EdifyFieldLabel label={`Select ${getHierarchyName(1, true)}`} />
          <EdifySearchDropdown
            multiSelect
            pillListWidth={'100%'}
            width={512}
            onSelect={levelsSelected}
            initialSelectedItems={selectedLevels}
            nameKey='name'
            globalSearchKey='levels'
          />
        </EdifyFormField>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}>
        <EdifyFormField>
          <EdifyFieldLabel label={`Select ${getHierarchyName(0, true)}`} />
          <EdifySearchDropdown
            multiSelect
            pillListWidth={'100%'}
            width={512}
            onSelect={projectsSelected}
            initialSelectedItems={selectedProjects}
            nameKey='name'
            globalSearchKey='projects'
          />
        </EdifyFormField>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}>
        <EdifyFormField>
          <EdifyFieldLabel label={'Select Contractors'} />
          <EdifySearchDropdown
            multiSelect
            pillListWidth={'100%'}
            width={512}
            onSelect={contractorsSelected}
            initialSelectedItems={selectedContractors}
            nameKey='name'
            globalSearchKey='contractors'
          />
        </EdifyFormField>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row-reverse',
          marginTop: '48px',
        }}
      >
        <Box>
          <EdifyButton onClick={handleSubmit} loading={loading} type='submit' primary title={'Save'} />
        </Box>
      </Box>
    </InnerPageContainer>
  )
}

export default FencesForm
